export default __webpack_public_path__ + "static/media/ir.01c0a08e.svg";